import axios from "axios";

const store = {
    state: {},

    getters: {},

    mutations: {},

    actions: {
        findLiders() {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/employees/lider-all`)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },


        storeSpentAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/spents/store`, payload)
                    .then((res) => {
                        resolve(res.data.spent);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        updateSpentAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/spents/update`, payload)
                    .then((res) => {
                        resolve(res.data.spent);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        deleteSpentAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/spents/delete/`, payload)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },


        deleteCaptureSpentAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/spents/delete-capture`, payload)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        findSpentByRangeAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/spents/find-by-range`, payload)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },

        findSpentByRangeAndEmployeeAction(Context, payload) {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/spents/find-by-range-and-employee`, payload)
                    .then((res) => {
                        resolve(res.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        }
    },
};

export default store;



